import React from "react";
import { Switch, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";
import TopMenu from "Components/TopMenu/TopMenu";
import PrivateRoute from "hoc/Routes/PrivateRoute/PrivateRoute";
import MaliSettings from "./MaliSettings/MaliSettings";
import { SettingsMenuItems } from "Constants/SettingsMenuItems";
import TarahiSettings from "./TarahiSettings/TarahiSettings";
import TolidSettings from "./TolidSettings/TolidSettings";
import ShopSettings from "./ShopSettings/ShopSettings";
import { read } from "Helpers/LocalStorage";

function Settings() {
  const { isLoggedIn } = useSelector((state) => ({
    isLoggedIn: state.auth.isLoggedIn,
  }));

  let updateSettingsMenuItems = [...SettingsMenuItems];
  SettingsMenuItems.map((item) => {
    if (item.menu_title === "tanzimatTarahi") {
      item.active = read("settingDesignerRules");
      return null;
    }
    if (item.menu_title === "tanzimatGozareshatTolide") {
      item.active = read("settingConstructRules");
      return null;
    }
    if (item.menu_title === "tanzimatGozareshatMali") {
      item.active = read("settingFactorRules");
      return null;
    }
  });

  return (
    <div className="properties">
      <TopMenu menuItems={updateSettingsMenuItems} />
      <div className="propertiesContent">
        <Switch>
          <Redirect
            exact
            from="/dashboard/settings"
            to="/dashboard/settings/invoice"
          />
          {/*  <Redirect
            exact
            from="/dashboard/settings"
            to="/dashboard/settings/maliSettings"
          /> */}
          <PrivateRoute
            exact
            path="/dashboard/settings/invoice"
            component={MaliSettings}
            isLoggedIn={isLoggedIn}
          />
          <PrivateRoute
            exact
            path="/dashboard/settings/construction"
            component={TolidSettings}
            isLoggedIn={isLoggedIn}
          />
          <PrivateRoute
            exact
            path="/dashboard/settings/design"
            component={TarahiSettings}
            isLoggedIn={isLoggedIn}
          />
          <PrivateRoute
            exact
            path="/dashboard/settings/shop"
            component={ShopSettings}
            isLoggedIn={isLoggedIn}
          />
        </Switch>
      </div>
    </div>
  );
}
export default Settings;
